export interface CustomerPortalResponse {
  portal_url: string;
}

export enum ClineaseSubscriptionStatus {
  ACTIVE = 'active',
  CANCELED = 'canceled',
}

export interface SubscriptionData {
  status: ClineaseSubscriptionStatus;
  current_period_end: string | null; // Current period end date in the format DD/MM/YYYY. None if the subscription is in the 'canceled' status
  cancel_at_period_end: boolean; // Whether this subscription will (if status=active) or did (if status=canceled) cancel at the end of the current billing period.
}

export interface ModifySubscriptionAtPeriodEndResponse {
  cancel_at_period_end: boolean;
}
